import { get } from "lodash";
import PropTypes from "prop-types";
import React from "react";
import { Link, withRouter } from "react-router-dom";
import { Button, Table } from "semantic-ui-react";

const CaseStatusesTable = ({ caseStatuses, match }) => (
	<Table selectable>
		<Table.Header>
			<Table.Row>
				<Table.HeaderCell>Globalny identyfikator sprawy</Table.HeaderCell>
				<Table.HeaderCell>Nr identyfikacyjny pisma</Table.HeaderCell>
				<Table.HeaderCell>Status</Table.HeaderCell>
				<Table.HeaderCell>Nazwa instytucji</Table.HeaderCell>
				<Table.HeaderCell>Osoba zajmująca się sprawą</Table.HeaderCell>
				<Table.HeaderCell>Data utworzenia</Table.HeaderCell>
				<Table.HeaderCell>Przewidywana data zakończenia sprawy</Table.HeaderCell>
				<Table.HeaderCell />
			</Table.Row>
		</Table.Header>
		<Table.Body>
			{caseStatuses.map(caseStatus => (
				<Table.Row key={caseStatus.caseStatusId}>
					<Table.Cell>{get(caseStatus, "globalId")}</Table.Cell>
					<Table.Cell>{get(caseStatus, "uid")}</Table.Cell>
					<Table.Cell>{get(caseStatus, "statusPubliczny")}</Table.Cell>
					<Table.Cell>{get(caseStatus, "merytorycznaKomorka")}</Table.Cell>
					<Table.Cell>{get(caseStatus, "official")}</Table.Cell>
					<Table.Cell>{get(caseStatus, "createDate")}</Table.Cell>
					<Table.Cell>{get(caseStatus, "timeToFinish")}</Table.Cell>
					<Table.Cell>
						<Button as={Link} basic icon="arrow right" to={`${match.url}/${caseStatus.caseStatusId}`} />
					</Table.Cell>
				</Table.Row>
			))}
		</Table.Body>
	</Table>
);

CaseStatusesTable.propTypes = {
	caseStatuses: PropTypes.array.isRequired,
	match: PropTypes.shape({
		url: PropTypes.string
	}).isRequired
};

const enhance = withRouter;

export { CaseStatusesTable, enhance };
export default enhance(CaseStatusesTable);



// WEBPACK FOOTER //
// ./src/containers/case-statuses-history/components/CaseStatusesTable.js